export default __webpack_public_path__ + "static/media/ductBank3.79701d89.jpg";